export default __webpack_public_path__ + "static/media/check-square.478880e1.svg";